import { Box } from '@mui/material';
import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataDataSteward } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import { useSelector } from 'react-redux';
import { dispatchCustomEvent } from 'tools/events';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function DataSteward(props: IElementDataDataSteward) {
    const {
        dataSteward: dataStewardName = '',
        dataStewardEmail = '',
        ownerEmailSubject = '',
        showOwnerIcon = true,
        settings,
    } = props;
    const fieldKey: ElementMetadataFieldName = 'data_steward';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    const ownersConfiguration = useSelector((state: any) => state.auth.configuration.owners);
    const isAppPanel = settings?.isAppPanel;

    if (!fieldMetadataDisplay || !dataStewardName) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowLabel
                icon={showOwnerIcon ? { type: 'mi', value: 'user' } : undefined}
                iconIndent={!showOwnerIcon}
            >
                {ownersConfiguration.data_steward.label}
            </ElementDataRowLabel>
            <ElementDataRowValue>
                {isAppPanel ? (
                    <Box
                        component={'span'}
                        sx={{
                            color: 'primary.main',
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            dispatchCustomEvent('mi-concierge-panel', {
                                action: 'owner-click',
                                payload: {
                                    userType: ownersConfiguration.data_steward.label,
                                    userName: dataStewardName,
                                    userMail: dataStewardEmail,
                                },
                            });
                        }}
                    >
                        {dataStewardName}
                    </Box>
                ) : (
                    <>
                        {dataStewardEmail ? (
                            <Box
                                component={'a'}
                                href={`mailto:${dataStewardEmail}${ownerEmailSubject ? '?subject=' + ownerEmailSubject : ''}`}
                            >
                                {dataStewardName}
                            </Box>
                        ) : (
                            <Box component={'span'}>{dataStewardName}</Box>
                        )}
                    </>
                )}
            </ElementDataRowValue>
        </ElementDataRow>
    );
}
